/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { LinkWrap } from '@/components/blocks/Linkable';
import { useLocalization } from '@/data/Localization';
import { useNavigation } from '@/data/Navigation';
import { FC } from 'react';
import { Box } from '@mui/material';
import { headerMobileDrawerBoxSX } from '@/components/content/Header/styles/mobileDrawer';
import { NavBarCategoriesMenu } from '@/components/content/Header/parts/Menu/NavBarCategoriesMenu';

export const HeaderMobileDrawer: FC = () => {
	const { navigation } = useNavigation();
	const { AllCategoriesLabel } = useLocalization('AllCategoriesExpandedMenu');
	const filteredNavigation = navigation ? navigation.filter(obj => { return obj.label === AllCategoriesLabel.t() }) : undefined;
	return (
		<Box sx={headerMobileDrawerBoxSX}>
			{filteredNavigation?.map(({ label, url, children }) => (
				<LinkWrap href={url} key={`${label}${url}`}>
					<NavBarCategoriesMenu tree={children} label={label} />
				</LinkWrap>
			))}
		</Box>
	);
};